var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8769_28977)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1 12.2C21.3938 12.2 19.2 14.3938 19.2 17.1C19.2 19.8062 21.3938 22 24.1 22C26.8062 22 29 19.8062 29 17.1C29 14.3938 26.8062 12.2 24.1 12.2ZM17 17.1C17 13.1788 20.1788 10 24.1 10C28.0212 10 31.2 13.1788 31.2 17.1C31.2 21.0212 28.0212 24.2 24.1 24.2C20.1788 24.2 17 21.0212 17 17.1Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 31.7C11 29.0925 13.0925 27 15.7 27H32.5C35.1075 27 37.2 29.0925 37.2 31.7V37.1H35V31.7C35 30.3075 33.8925 29.2 32.5 29.2H15.7C14.3075 29.2 13.2 30.3075 13.2 31.7V37.1H11V31.7Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8769_28977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.2,
    height: 27.1,
    fill: "white",
    transform: "translate(11 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserLight);
export default __webpack_public_path__ + "static/media/icon_user_light.1e9c918a.svg";
export { ForwardRef as ReactComponent };